import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'
import { useSelector } from 'react-redux';
import { Pagination } from 'antd';
import SubNav from './Common/SubNav';
import Footer from './Common/Footer';
import PkgGroupTbl from './Common/PkgGroupTbl';
import SelectList from './Common/SelectList';
import AlertMessage from './Common/AlertMessage';
import SearchBtn from './Common/SearchBtn';
import ConvertButtons from './Common/ConvertButtons';

const AllPackageGrp = ({ isShow, setIsShow }) => {
    const pkgTable = [
        {
            Sno: 1,
            pkgGroup: "Fitness"
        },
        {
            Sno: 2,
            pkgGroup: "Build Up"
        }

    ];
    const [data, setData] = useState(pkgTable);
    const [page, setPage] = useState(1);
    const [postPerPage, setPostPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');
    const dataRef = React.createRef();
    const { alert } = useSelector(state => state.alert);

    const isDelete = (item) => {
        const newData = data.filter(e => { return e.Sno !== item.Sno });
        setData(newData)
        console.log(newData);
    }
    const handleDelete = (item) => {
        confirmAlert({
            message: "Are you sure you want to Delete?",
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => isDelete(item)
                },
                {
                    label: 'Cancel',
                    onClick: () => null
                }
            ],
            overlayClassName: "react-confirm-alert-overlay react-confirm-alert-body"
        })
    };

    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <a>Previous</a>;
        } else if (type === 'next') {
            return <a>Next</a>;
        }
        return originalElement;
    };

    const indexOfLastPage = page * postPerPage;
    const indexOfFirstPage = indexOfLastPage - postPerPage;
    const currentPost = data.slice(indexOfFirstPage, indexOfLastPage);

    return (
        <div className='page_first_div '>
            <SubNav isShow={isShow} setIsShow={setIsShow} />
            <div className='page_sec_div'>
                <p className='page_topic inline-block'>All Package Groups</p>
                <div className='inline-block bg-cyan-600 px-3 py-1 ml-2 mb-2 rounded-md hover:bg-cyan-700 animation'>
                    <Link to="/admin/programgrp/" className='link block text-white text-sm'>
                        <i className="fa-solid fa-square-plus mr-1"></i>
                        Add
                    </Link>
                </div>
                <section className='page_section min-h-[23rem]'>

                    {/* showing success message when form updated */}
                    {alert && <AlertMessage />}

                    {/* selectors and search */}
                    <form className='flex flex-col lg:flex-row justify-center items-center gap-4 px-4 xsm:px-8 py-4  2xl:justify-start'>
                        <div className='font-lato w-full lg:w-auto'>
                            <select className="selector w-full lg:w-80 bg-gray-100">
                                <option selected>--Select status--</option>
                                <option value="Active" >Active</option>
                                <option value="Inactive">Inactive</option>
                            </select>
                        </div>
                        <SearchBtn
                            setSearchTerm={setSearchTerm}
                        />
                    </form>

                    {/* show option and convert buttons */}
                    <div className='pt-2 flex flex-col gap-4 justify-center md:justify-between px-4 xsm:px-8 md:flex-row'>
                        <SelectList
                            setPostPerPage={setPostPerPage}
                            data={data}
                        />
                        <ConvertButtons
                            data={data}
                            ref={dataRef}
                        />
                    </div>
                    {/* package group table data details */}
                    <PkgGroupTbl
                        data={currentPost}
                        sortData={data}
                        setData={setData}
                        onDelete={handleDelete}
                        searchTerm={searchTerm}
                        ref={dataRef}
                    />

                    {/* pagination and table length */}
                    <div className='px-4 xsm:px-8 py-3 flex flex-col gap-2 sm:flex-row sm:justify-between items-center'>
                        <p className='text-sm text-gray-800'>
                            showing {page} to {currentPost.length} of {data.length} entries
                        </p>
                        <Pagination
                            total={data.length}
                            onChange={value => setPage(value)}
                            itemRender={itemRender}
                            pageSize={postPerPage}
                            current={page}
                        />
                    </div>
                </section>
            </div>
            <Footer />
        </div>
    )
}

export default AllPackageGrp;